<h1>{{ 'account.punchout.configuration.heading' | translate }}</h1>

<p>{{ 'account.punchout.configuration.description' | translate }}</p>

<ish-oci-configuration-form />
